import React, { useMemo } from "react";
import { useLocation } from "react-router";

const SelectField = ({
  view = false,
  labelName = "",
  name = "",
  register,
  id = "",
  type = "text",
  errors,
  errorText = "",
  placeholder = "",
  isRequired = true,
  defaultValue = "",
  options = [],
  defaultOption = "",
  className = "",
  isOptionObject = false,
  selectedDataId = "",
  getValues = () => {},
}) => {
  const location = useLocation();
  const isEdit = location.pathname.includes("edit");

  const value = isEdit && getValues(name)?.length > 0 ? getValues(name) : null;

  const memoizedOptions = useMemo(() => {
    return isOptionObject
      ? options.filter(
          ({ active = null, value }) =>
            active === null || active || selectedDataId === value
        )
      : options;
  }, [options, isOptionObject, selectedDataId]);
  return (
    <>
      <label className="form-label title mb-2" htmlFor={id}>
        {labelName} {isRequired ? <span className="star">*</span> : null}
      </label>
      <select
        {...register(name, { required: isRequired })}
        className={`${className} form-control w-75`}
        style={{ height: "50px" }}
        defaultValue={defaultValue}
        // value={value}
        disabled={view}
      >
        <option value="" disabled pri-specialization="true">
          Select {defaultOption}
        </option>
        {memoizedOptions.map((data, idx) => {
          return (
            <option key={idx} value={isOptionObject ? data?.value : data}>
              {isOptionObject ? data?.label : data}
            </option>
          );
        })}
      </select>

      {getValues(name)?.length > 0
        ? errors[name] && getValues(name).length < 0
        : errors[name] && (
            <div className={`invalid-feedback d-block`}>{errorText}</div>
          )}
    </>
  );
};

export default SelectField;
